import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";
import {Additional} from "./additional";
import {Observable} from "rxjs/Observable";
import {PointOfSaleA2Service} from "../../core/point-of-sale.service.service";

@Injectable()
export class AdditionalService {
    private baseUrl: string = '../rest/';

    constructor(private http : Http, private posService: PointOfSaleA2Service) {}

    list(){
        return this.http
            .get(`../rest/additionals`, { headers: this.getHeaders()})
            .map((response) => <Additional[]>response.json());
    }

    getData(companyId:number): any {
        return Observable.forkJoin([
            this.getPointsOfSale(companyId),
            this.getAdditionals(companyId)
        ]);
    }

    loadAdditionalPrice(companyId, id){
        return this.get(companyId,id);
    }

    get(companyId, id){
        return this.http
            .get(`../rest/company/${companyId}/additionals/${id}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    private getHeaders(){
        let hdrs = new Headers();
        hdrs.append('Content-Type', 'application/json');
        return hdrs;
    }

    saveToll(toll: any, companyOid, id) {
        let endpoint = `../rest/company/${companyOid}/additionals/tolls`;
        let subscription;
        if(!!id){
            endpoint.concat(`/${id}`);
            subscription = this.http.put(endpoint, toll);
        }else{
            subscription = this.http.post(endpoint, toll);
        }
        return subscription;
    }

    saveAdditional(additional: any, companyOid, id) {
        let endpoint = `../rest/company/${companyOid}/additionals`;
        let subscription;
        if(!!id){
            endpoint.concat(`/${id}`);
            subscription = this.http.put(endpoint, additional);
        }else{
            subscription = this.http.post(endpoint, additional);
        }
        return subscription;
    }

    private getPointsOfSale(companyId: number) {
        return this.posService.get(companyId);
    }

    private getAdditionals(companyId: number) {
        return this.list();
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional.service.ts